import { render } from "./settlementAudit.vue?vue&type=template&id=8d8b18ea"
import script from "./settlementAudit.vue?vue&type=script&lang=js"
export * from "./settlementAudit.vue?vue&type=script&lang=js"

import "./settlementAudit.vue?vue&type=style&index=0&id=8d8b18ea&lang=css"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__